var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.dataLoaded && _vm.data.feedbacks.length > 0
    ? _c("div", { staticClass: "ts-widget" }, [
        _c("div", { staticClass: "fxc" }, [
          _c("div", { staticClass: "h1 dot" }, [
            _vm._v(_vm._s(_vm.$attrs.headline)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top" }, [
            _c("div", { staticClass: "rate" }, [
              _c("div", { staticClass: "rating-txt" }, [
                _c("div", { staticClass: "stars" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "full",
                      style: "width:" + parseFloat(_vm.data.fb_avg) * 20 + "%",
                    },
                    [
                      _c("i", { staticClass: "fa fa-star" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-star" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-star" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-star" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-star" }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.data.fb_avg.replace(".0", "")) + "/5"),
                  ]),
                  _vm._v(
                    " (" +
                      _vm._s(_vm.data.fb_count_total) +
                      " " +
                      _vm._s(_vm.$attrs.text) +
                      ")"
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$attrs.itemName))]),
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "icon-ekomigold" }),
            _vm._v(" "),
            _c("i", { staticClass: "icon-ekomigoldxxl" }),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            [
              _vm._l(_vm.data.feedbacks, function (feedback, index) {
                return [
                  _c("li", [
                    _c("div", [
                      _c(
                        "span",
                        [
                          _vm._l(Number(feedback.rating), function (n) {
                            return _c("i", { staticClass: "fa fa-star" })
                          }),
                          _vm._v(" "),
                          _vm._l(5 - Number(feedback.rating), function (n) {
                            return Number(feedback.rating) < 5
                              ? _c("i", { staticClass: "fa fa-star grey" })
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _c("strong", [_vm._v(_vm._s(feedback.date))]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "txt",
                        domProps: { innerHTML: _vm._s(feedback.review) },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.data.feedbacks.length > 4 && index == 3
                    ? _c("input", {
                        attrs: { type: "checkbox", id: "showMore" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data.feedbacks.length > 4 && index == 3
                    ? _c("label", { attrs: { for: "showMore" } }, [
                        _vm._v(_vm._s(_vm.$attrs.more)),
                      ])
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "blank" }, [
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }